import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { usersByEmail } from "../graphql/queries";
import { UsersByEmailQuery } from "../API";

export async function fetchUsersByEmail(
  email: string
): Promise<GraphQLResult<UsersByEmailQuery>> {
  return API.graphql(
    graphqlOperation(usersByEmail, {
      email: email.toLowerCase(),
    })
  ) as Promise<GraphQLResult<UsersByEmailQuery>>;
}
